module.exports = __webpack_public_path__ + "img/vrsmash.3c5f55af.png";